import type { RunToDatabase } from '@/types'
import { getAssistantPendingProposalCount } from '@pkg/database-portfolio'
import { getDefaultStore } from 'jotai'
import { assistantPendingProposalCountAtomFamily } from '../states/analysis'

/** DBのraw pending countを読み、portfolio別session atomへ反映する。 */
export const updateAssistantPendingCount = async ({
  portfolioId,
  readFromDatabase,
}: {
  readonly portfolioId: string
  readonly readFromDatabase: RunToDatabase
}): Promise<number> => {
  const count = await readFromDatabase((database) =>
    getAssistantPendingProposalCount({ database }),
  )
  getDefaultStore().set(
    assistantPendingProposalCountAtomFamily(portfolioId),
    count,
  )
  return count
}
